import { Badge, Tooltip } from '@fluentui/react-components';

import { ConsentStatus } from '../api/tenantRegistry';

// Renders the ADR-023 tenant consent verdict as a Fluent Badge with the three
// states kept visually distinct (frontend design direction + backend semantics):
//   consented    → success (green)  — verified, all roles present
//   insufficient → warning (amber)  — verified, roles missing → real action needed
//   unknown      → subtle  (zinc)   — the consent read FAILED → "couldn't verify"
//                                      (NOT the same as insufficient)
// The `unknown` chip carries a tooltip so the "couldn't verify" meaning is
// explicit rather than read as "no consent".
export default function ConsentStatusChip({ status }: { status: ConsentStatus }) {
  if (status === 'consented') {
    return (
      <Badge appearance="tint" color="success">
        Consented
      </Badge>
    );
  }
  if (status === 'insufficient') {
    return (
      <Badge appearance="tint" color="warning">
        Action needed
      </Badge>
    );
  }
  // unknown
  return (
    <Tooltip
      relationship="description"
      content="The consent state could not be verified on the last check. This is not the same as missing consent — re-check to try again."
    >
      <Badge appearance="tint" color="subtle">
        Unverified
      </Badge>
    </Tooltip>
  );
}
